export default {
  init() {
    $('.testimonies-slider').slick({
      prevArrow: $('.testimonies-slider').parent().find('.prev'),
      nextArrow: $('.testimonies-slider').parent().find('.next'),
      arrows: true,
      infinite: true,
    });

    $('.slide-portafolio').slick({
      prevArrow: $('.works-home .prev'),
      nextArrow: $('.works-home .next'),
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
          },
        },
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js